import { useEffect, useState } from 'react';
import { getEnvironment } from '../../helpers';

export const useEnvironment = () => {
    const [env, setEnv] = useState('');
    const [buttons, setButtons] = useState('');
    const [hasLogin, setHasLogin] = useState(false);
    const [splashPage, setSplashPage] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState('');
    const [errorPath, setErrorPath] = useState('');
    const [loginPath, setLoginPath] = useState('');
    const [enforceToken, setEnforceToken] = useState(false);
    const [editServiceAddress, setEditServiceAddress] = useState(false);
    const [environmentLoading, setEnvironmentLoading] = useState(true);

    useEffect(() => {
        const fetchEnv = async () => {
            try {
                const env = await getEnvironment();
                const envLower = env.environment.toLowerCase();
                const brandButtons = env.brandingButtons;
                const login = env.hasAccount;
                const splashPage = env.showSplashPage;
                const redirectUrl = env.redirect;
                const errorPath = env.errorPath;
                const loginPath = env.loginPath;
                const enforceToken = env.enforceToken;
                const editServiceAddress = env.editServiceAddress;
                setEnv(envLower);
                setButtons(brandButtons);
                setHasLogin(login);
                setSplashPage(splashPage);
                setRedirectUrl(redirectUrl);
                setErrorPath(errorPath);
                setLoginPath(loginPath);
                setEnforceToken(enforceToken);
                setEditServiceAddress(editServiceAddress);
            } catch (error) {
                console.error('Failed to load');
            } finally {
                setEnvironmentLoading(false);
            }
        };
        fetchEnv();
    }, []);

    const isLocal = env === 'local';
    const isDevelopment = env === 'development';
    const isStaging = env === 'staging';
    const isProduction = env === 'production';
    const isAnyNonProduction = env !== 'production';

    return {
        isLocal,
        isDevelopment,
        isStaging,
        isProduction,
        isAnyNonProduction,
        isStagingOrLower: isLocal || isDevelopment || isStaging,
        isDevOrLower: isLocal || isDevelopment,
        showBrandButtons: buttons,
        hasLogin,
        splashPage,
        redirectUrl,
        errorPath,
        loginPath,
        enforceToken,
        editServiceAddress,
        environmentLoading
    };
};
